import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ba5fe30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba5fe30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba5fe30')) {
      api.createRecord('2ba5fe30', component.options)
    } else {
      api.reload('2ba5fe30', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ba5fe30&scoped=true", function () {
      api.rerender('2ba5fe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/index.vue"
export default component.exports